module.exports = __webpack_public_path__ + "static/media/Maps.955dff85.png";